// // import React, { useState, useEffect } from "react";
// // import { connect } from "react-redux";
// // import { bindActionCreators } from "redux";
// // import actions from "../../actions";
// // import styles from "../Chat/Chat.module.css";
// // import { io } from "socket.io-client";
// // import { getSupportUser } from "../../apis";

// // const HelpCenter = ({ startLoadingRequest, stopLoadingRequest }) => {
// //   const [users, setUsers] = useState([]);
// //   const [message, setMessage] = useState("");
// //   const [messages, setMessages] = useState([]); // Ensure this is an array
// //   const [selectUser, setSelectUser] = useState(null);
// //   const [media, setMedia] = useState([]);
// //   const [selectedUser, setSelectedUser] = useState(null);
// //   const [socket, setSocket] = useState(null);
// //   const [chats, setChats] = useState([]);
// //   const [userid, setUserid] = useState(null);

// //   useEffect(() => {
// //     stopLoadingRequest();

// //     // Fetch user details from localStorage once and set userid
// //     const userDetails = localStorage.getItem("userDetails");
// //     if (userDetails) {
// //       const user_id = JSON.parse(userDetails)._id;
// //       setUserid(user_id);
// //     }
// //   }, []);

// //   const handleUserClick = (user) => {
// //     setSelectedUser(user);
// //     // Fetch chat data for the selected user and update the chats state
// //   };

// //   const handleSendMessage = () => {
// //     console.log("hit send", selectUser);
// //     console.log(message);
// //     const userDetails = localStorage.getItem("userDetails");

// //     if (userDetails) {
// //       console.log(userDetails, "11111");
// //       const user_id = JSON.parse(userDetails)._id;
// //       const senderId = user_id;
// //       const receiverId = selectUser.userId._id;
// //       const roomId = selectUser.roomId;

// //       socket.emit(
// //         "support_send_message",
// //         message,
// //         senderId,
// //         receiverId,
// //         roomId,
// //         media
// //       );
// //       setMessage("");
// //     }
// //   };

// //   const loadChat = (user) => {
// //     const userDetails = localStorage.getItem("userDetails");
// //     const user_id = JSON.parse(userDetails);
// //     const senderId = user_id?._id;
// //     const receiverId = user?.userId?._id;
// //     if (socket) {
// //       socket.emit("load_chat_support", senderId, receiverId);
// //     }
// //   };

// //   useEffect(() => {
// //     const fetchUser = async () => {
// //       const response = await getSupportUser();
// //       console.log(response);
// //       setUsers(response?.data?.data || []); // Fallback to empty array if no users
// //     };
// //     fetchUser();
// //   }, []);

// //   useEffect(() => {
// //     const newSocket = io("https://6c61-45-118-166-186.ngrok-free.app/", {
// //       extraHeaders: { "ngrok-skip-browser-warning": "any-value" },
// //     });
// //     newSocket.on("connect", () => {
// //       setSocket(newSocket);
// //     });
// //     return () => {
// //       if (newSocket) {
// //         newSocket.disconnect();
// //       }
// //     };
// //   }, []);

// //   useEffect(() => {
// //     const userDetails = localStorage.getItem("userDetails");
// //     const user_id = JSON.parse(userDetails);

// //     if (!socket) return;

// //     const handleAdminMessageReceived = (item) => {
// //       console.log(item, "35");
// //       setMessages((prevMessages) => [...prevMessages, item]);
// //     };

// //     const handleLoadAdminChat = (item) => {
// //       console.log(item);
// //       // Ensure the response is an array
// //       setMessages(Array.isArray(item) ? item : []); // Ensure messages is an array
// //     };
// //     socket.on("support_send_message_received", handleAdminMessageReceived);
// //     socket.on("support_message_received", handleLoadAdminChat);

// //     return () => {
// //       socket.off("message_received", handleAdminMessageReceived);
// //       socket.off("loadAdminChat", handleLoadAdminChat);
// //     };
// //   }, [socket]);

// //   const renderOptions = (options) => {
// //     return (
// //       <div className={styles.optionsContainer}>
// //         {options.map((option, index) => (
// //           <button key={index} className={styles.optionButton}>
// //             {option}
// //           </button>
// //         ))}
// //       </div>
// //     );
// //   };

// //   return (
// //     <div className="section chatContainer">
// //       <div className={styles.userList}>
// //         {users?.map((user, index) => (
// //           <div
// //             key={index}
// //             className={styles.userItem}
// //             onClick={() => {
// //               console.log(user);
// //               setSelectUser(user);
// //               loadChat(user);
// //             }}
// //           >
// //             {user?.userName || "No name available"}
// //           </div>
// //         ))}
// //       </div>
// //       <div className={styles.chatWindow}>
// //         {selectUser ? (
// //           <>
// //             <div className={styles.chatHeader}>
// //               Chat with {selectUser?.userId?.firstName || "User"}
// //             </div>
// //             <div className={styles.chatMessages}>
// //               {/* Fallback to empty array if messages is not an array */}
// //               {Array.isArray(messages) && messages.length > 0 ? (
// //                 messages.map((chat) => (
// //                   <div key={chat._id}>
// //                     <div
// //                       className={
// //                         chat.senderId === userid
// //                           ? styles.adminMessage
// //                           : styles.userMessage
// //                       }
// //                     >
// //                       {chat.message}
// //                       {chat.senderId === userid &&
// //                         chat.options &&
// //                         chat.options.length > 0 &&
// //                         renderOptions(chat.options)}
// //                     </div>
// //                   </div>
// //                 ))
// //               ) : (
// //                 <div>No messages available</div>
// //               )}
// //             </div>
// //             <div className={styles.chatInput}>
// //               <input
// //                 onChange={(e) => {
// //                   setMessage(e.target.value);
// //                 }}
// //                 value={message}
// //                 type="text"
// //                 placeholder="Type a message..."
// //               />
// //               <button onClick={handleSendMessage}>Send</button>
// //             </div>
// //           </>
// //         ) : (
// //           <div className={styles.noChatSelected}>
// //             Select a user to start chatting
// //           </div>
// //         )}
// //       </div>
// //     </div>
// //   );
// // };

// // const mapDispatchToProps = (dispatch) =>
// //   bindActionCreators(
// //     {
// //       logoutRequest: actions.auth.logout,
// //       startLoadingRequest: actions.loader.startLoading,
// //       stopLoadingRequest: actions.loader.stopLoading,
// //     },
// //     dispatch
// //   );

// // export default connect(null, mapDispatchToProps)(HelpCenter);

// import React, { useState, useEffect } from "react";
// import { connect } from "react-redux";
// import { bindActionCreators } from "redux";
// import actions from "../../actions";
// import styles from "../Chat/Chat.module.css";
// import { io } from "socket.io-client";
// import { getSupportUser } from "../../apis";

// const HelpCenter = ({ startLoadingRequest, stopLoadingRequest }) => {
//   const [users, setUsers] = useState([]);
//   const [message, setMessage] = useState("");
//   const [messages, setMessages] = useState([]); // Ensure this is an array
//   const [selectUser, setSelectUser] = useState(null);
//   const [media, setMedia] = useState([]);
//   const [selectedUser, setSelectedUser] = useState(null);
//   const [socket, setSocket] = useState(null);
//   const [chats, setChats] = useState([]);
//   const [userid, setUserid] = useState(null);

//   useEffect(() => {
//     stopLoadingRequest();

//     // Fetch user details from localStorage once and set userid
//     const userDetails = localStorage.getItem("userDetails");
//     if (userDetails) {
//       const user_id = JSON.parse(userDetails)._id;
//       setUserid(user_id);
//     }
//   }, []);

//   const handleUserClick = (user) => {
//     console.log(user);

//     setSelectedUser(user);
//     loadChat(user);
//   };

//   const handleSendMessage = () => {
//     console.log("hit send", selectUser);
//     console.log(message);
//     const userDetails = localStorage.getItem("userDetails");

//     if (userDetails) {
//       const user_id = JSON.parse(userDetails)._id;
//       const senderId = user_id;
//       const receiverId = selectUser.userId._id;
//       const roomId = selectUser.roomId;

//       // Emit the message to the server
//       socket.emit(
//         "support_send_message",
//         message,
//         senderId,
//         receiverId,
//         roomId,
//         media
//       );

//       // Clear the message input after sending
//       setMessage("");
//     }
//   };

//   const loadChat = (user) => {
//     const userDetails = localStorage.getItem("userDetails");
//     const user_id = JSON.parse(userDetails);
//     const senderId = user_id?._id;
//     const receiverId = user?.userId;
//     if (socket) {
//       socket.emit("load_chat_support", senderId, receiverId);
//     }
//   };

//   useEffect(() => {
//     const fetchUser = async () => {
//       const response = await getSupportUser();
//       setUsers(response?.data?.data || []);
//     };
//     fetchUser();
//   }, []);

//   useEffect(() => {
//     const newSocket = io("https://6c61-45-118-166-186.ngrok-free.app/", {
//       extraHeaders: { "ngrok-skip-browser-warning": "any-value" },
//     });
//     newSocket.on("connect", () => {
//       setSocket(newSocket);
//     });
//     return () => {
//       if (newSocket) {
//         newSocket.disconnect();
//       }
//     };
//   }, []);

//   useEffect(() => {
//     const userDetails = localStorage.getItem("userDetails");
//     const user_id = JSON.parse(userDetails);

//     if (!socket) return;

//     // Handle receiving a message
//     const handleAdminMessageReceived = (message) => {
//       console.log("Received message:", message);
//       setMessages((prevMessages) => [...prevMessages, message]);
//     };

//     // Handle loading chat history for the support user
//     const handleLoadChatSupport = (chatData) => {
//       console.log("Loaded chat data:", chatData);
//       setMessages(Array.isArray(chatData) ? chatData : []); // Ensure the chatData is an array
//     };

//     // Listen to the events
//     socket.on("support_message_received", handleAdminMessageReceived);
//     socket.on("load_chat_support", handleLoadChatSupport);

//     return () => {
//       // Clean up the event listeners on component unmount
//       socket.off("support_message_received", handleAdminMessageReceived);
//       socket.off("load_chat_support", handleLoadChatSupport);
//     };
//   }, [socket]);

//   const renderOptions = (options) => {
//     return (
//       <div className={styles.optionsContainer}>
//         {options.map((option, index) => (
//           <button key={index} className={styles.optionButton}>
//             {option}
//           </button>
//         ))}
//       </div>
//     );
//   };

//   return (
//     <div className="section chatContainer">
//       <div className={styles.userList}>
//         {users?.map((user, index) => (
//           <div
//             key={index}
//             className={styles.userItem}
//             onClick={() => handleUserClick(user)}
//           >
//             {user?.userName || "No name available"}
//           </div>
//         ))}
//       </div>
//       <div className={styles.chatWindow}>
//         {selectUser ? (
//           <>
//             <div className={styles.chatHeader}>
//               Chat with {selectUser?.userId?.firstName || "User"}
//             </div>
//             <div className={styles.chatMessages}>
//               {Array.isArray(messages) && messages.length > 0 ? (
//                 messages.map((chat) => (
//                   <div key={chat._id}>
//                     <div
//                       className={
//                         chat.senderId === userid
//                           ? styles.adminMessage
//                           : styles.userMessage
//                       }
//                     >
//                       {console.log(chat)}
//                       {chat.message}
//                       {chat.senderId === userid &&
//                         chat.options &&
//                         chat.options.length > 0 &&
//                         renderOptions(chat.options)}
//                     </div>
//                   </div>
//                 ))
//               ) : (
//                 <div>No messages available</div>
//               )}
//             </div>
//             <div className={styles.chatInput}>
//               <input
//                 onChange={(e) => setMessage(e.target.value)}
//                 value={message}
//                 type="text"
//                 placeholder="Type a message..."
//               />
//               <button onClick={handleSendMessage}>Send</button>
//             </div>
//           </>
//         ) : (
//           <div className={styles.noChatSelected}>
//             Select a user to start chatting
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// const mapDispatchToProps = (dispatch) =>
//   bindActionCreators(
//     {
//       logoutRequest: actions.auth.logout,
//       startLoadingRequest: actions.loader.startLoading,
//       stopLoadingRequest: actions.loader.stopLoading,
//     },
//     dispatch
//   );

// export default connect(null, mapDispatchToProps)(HelpCenter);

import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import actions from "../../actions";
import styles from "../Chat/Chat.module.css";
import { io } from "socket.io-client";
import { CloseSupportChatByRoomID, getSupportUser } from "../../apis";
import { toast } from "react-toastify";

const HelpCenter = ({ startLoadingRequest, stopLoadingRequest }) => {
  const [users, setUsers] = useState([]);
  const [message, setMessage] = useState("");
  const [messages, setMessages] = useState([]); // Ensure this is an array
  const [selectUser, setSelectUser] = useState(null);
  const [userid, setUserid] = useState(null); // Current user ID
  const [socket, setSocket] = useState(null);
  const [userDetails,setUserDetails]=useState(JSON.parse(localStorage.getItem("userDetails")));

  
  // sender ID ADMIN

  const senderId = "admin";

  const chatEndRef = useRef(null); 

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]); // Scrolls when messages update

// let isChatAssigendToCurrentAdmin= messages[messages.length-1].assignedAdmin===userDetails?._id
// console.log("isChatAssigendToCurrentAdmin",isChatAssigendToCurrentAdmin)
const isAdminAssigned=messages?.length>0&& messages[messages?.length-1]?.assignedAdmin
const currentAdmin=userDetails?._id

  // Load user details from local storage and set the user ID
  useEffect(() => {
    stopLoadingRequest();
    const userDetails = localStorage.getItem("userDetails");
    if (userDetails) {
      const user_id = JSON.parse(userDetails)._id;
      setUserid(user_id);
    }
  }, []);


  const markMessagesAsSeen = (roomId, receiverId) => {
 
    if (socket) {
        socket.emit("mark_messages_as_seen", roomId, receiverId);
    }
};


  // Handle user click and load the chat for that user
  const handleUserClick = (user) => {
   
    setSelectUser(user);

    const receiverId = user.userId;

    socket.emit("join_support_room", senderId, receiverId); 
    const roomID = receiverId+'_admin' 
    markMessagesAsSeen( roomID ,'admin')
    loadChat(user);
   
  };

  // Handle sending a message
  const handleSendMessage = () => {
     if (message && selectUser && socket) {
      const senderId = "admin";
      const receiverId = selectUser.userId;
      const roomId = selectUser.roomIds;
      const assignedAdmin=userDetails?._id

      // Emit the message to the server
      socket.emit(
        "support_send_message",
        message,
        senderId,
        receiverId,
        // roomId,
        assignedAdmin
      );

      // FOR NOW ONLY CHECK THIS 

      // socket.emit(
      //   "send_message_bot",
      //   'dsfg',
      //   '67b86bc8c72bd372e2d21adc',
      //   '66b20db5f8aa4622bd836c91',
      //   '66b20db5f8aa4622bd836c91_67b86bc8c72bd372e2d21adc'
      // );
      
      // Clear the message input after sending
      setMessage("");
    }
  };

  // Load chat messages for the selected user
  const loadChat = (user) => {
    if (socket) {
     
      const receiverId = user.userId;

      

      socket.emit("load_chat_support", senderId, receiverId);
    }
  };

  // Fetch support users
  useEffect(() => {
    const fetchUser = async () => {
      const response = await getSupportUser();
      // console.log("getSupportUser",response)
      setUsers(response?.data?.data || []); // Ensure users is an array
    };
    fetchUser();
  }, []);
  // }, [messages]);

  // Initialize socket connection
  useEffect(() => {
    // const URL =  "ws://localhost:10042" 
    const URL =  "wss://dev-api.ponderiee.com"  || "ws://localhost:10041" 
    const newSocket = io(URL, {
      
      extraHeaders: { "ngrok-skip-browser-warning": "any-value" },
    });
    newSocket.on("connect", () => {
      setSocket(newSocket);
    });
    return () => {
      if (newSocket) {
        newSocket.disconnect();
      }
    };
  }, []);
  

  

  // Listen for incoming messages and load chat history
  useEffect(() => {
    if (!socket) return;
    

    const handleAdminMessageReceived = (message) => {
      setMessages((prevMessages) => [...prevMessages, message]); // Append new messages
    };

    const handleLoadChatSupport = (chatData) => {
      setMessages(Array.isArray(chatData) ? chatData : []); // Ensure it's an array
    };

    const handleMessagesSeen = ({ roomId, receiverId }) => {
      setMessages((prevMessages) =>
          prevMessages.map((msg) =>
              msg.receiverId === receiverId ? { ...msg, seen: true } : msg
          )
      );
  };

    socket.on("support_message_received", handleAdminMessageReceived);
    // socket.emit("load_chat_support", senderId, receiverId);

    socket.on("load_chat_support", handleLoadChatSupport);
    socket.on("load_chat_support", handleLoadChatSupport);
    socket.on("messages_seen", handleMessagesSeen);

    // socket.emit("load_chat", '67722f36f73fa75138a1f85a');

    // socket.emit("option_selected", 12, "67c0206d9f514b4ebd6ccb4c", "bot", "67c0206d9f514b4ebd6ccb4c_bot");
// 


    return () => {
      socket.off("support_message_received", handleAdminMessageReceived);
      socket.off("load_chat_support", handleLoadChatSupport);
      socket.off("messages_seen", handleMessagesSeen);
    };
  }, [socket]);

  // Render chat options
  const renderOptions = (options) => {
    return (
      <div className={styles.optionsContainer}>
        {options.map((option, index) => (
          <button key={index} className={styles.optionButton}>
            {option}
          </button>
        ))}
      </div>
    );
  };


  const handleCloseChat = async () => {

    if (!selectUser) return;
    try {
      const roomId = selectUser.roomId; 
     const closedRes =  await CloseSupportChatByRoomID(roomId);
     setSelectUser(prev => ({ ...prev, status: "close" }));

    } catch (error) {
      console.error("Error closing chat:", error);
      if(error.response.status===403){
        toast.error(error.response.data.message)
      }
    }
  };
  
  
  const onKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault(); // Prevent newline
      if (message.trim()) {
        handleSendMessage(message);
        setMessage('');
      }
    }
  };

  const onClickSend = () => {
    if (message.trim()) {
      handleSendMessage(message);
      setMessage('');
    }
  };
  
  const openChats = users?.filter(user => user.status === "open") || [];
  const closedChats = users?.filter(user => user.status === "close") || [];
  const inactiveChats = users?.filter(user => user.status === "Inactive") || [];
  // render chat 
  // console.log("openChats",openChats);

  const renderChatList = (chatList, title) => (
    chatList.length > 0 && (
      <div style={{marginBottom:"50px"}}>
        {/* <hr /> */}
        <b className={styles.chatCategory}>{title}</b>
        {/* <hr /> */}
        <div style={{height:"250px",overflowY:"scroll"}}>

        {chatList.map((user, index) => (
          <div style={{display:'flex',justifyContent:'space-between',borderBottom:'1px solid grey'}}>
          <div style={{display:'flex',alignItems:'center',width:'100%', backgroundColor: selectUser?._id === user._id ? "#ccc" : "transparent",}} 
          
      >
          <div className={styles.avatar}>{(user?.userName?.charAt(0))}</div>
           <div
             key={index}
             
             className={styles.userItem}
             onClick={() => handleUserClick(user)}
            
           >
             {user?.userName?.slice(0,12) || "Unknown"}
             <br/>
             <i style={{fontSize:'12px'}}>{user?.lastMessage?.slice(0,20)}..</i>   
             {/* <span>{user?.chatStatus}</span> */}
           </div>
           {user?.unseenCount > 0 &&  <div className={styles.unseenCount}>{user?.unseenCount}</div>}
          </div>
          
         
          </div>
        ))}
        </div>
      </div>
    )
  );
  function getFormattedDate(date) {
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);

  if (date.toDateString() === today.toDateString()) return "Today";
  if (date.toDateString() === yesterday.toDateString()) return "Yesterday";

  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

function formatTime(dateString) {
  const date = new Date(dateString);
  return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
}
  return (
    <div className="section chatContainer">
      <div className={styles.userList} >

      {renderChatList(openChats, "Open Chats")}
    {renderChatList(closedChats, "Closed Chats")}
    {renderChatList(inactiveChats, "Inactive Chats")}

      
      </div>
      <div className={styles.chatWindow}>
        {selectUser ? (
          <>
            <div className={styles.chatHeader} style={{display:'flex',justifyContent:'space-between',width:'100%'}}>
              <p>Chat with {selectUser?.userName || "User"}</p>
              {selectUser?.status !== "close" &&  <button onClick={handleCloseChat} style={{background:'#333',borderRadius:'8px'}}>Close Chat</button> }
             
            </div>
            <div className={styles.chatMessages}>
  {Array.isArray(messages) && messages.length > 0 ? (
    messages.map((chat, index) => {
      const currentDate = new Date(chat.createdAt);
      const prevDate =
        index > 0 ? new Date(messages[index - 1].createdAt) : null;

      // Check if this chat starts a new date section
      const isNewDate =
        !prevDate ||
        currentDate.toDateString() !== prevDate.toDateString();

      const formattedDate = getFormattedDate(currentDate);

      return (
        <React.Fragment key={chat._id}>
          {isNewDate && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                margin: "10px 0",
                color: "grey",
                fontSize: "12px",
                position: "relative",
                width: "100%",
              }}
            >
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  width: "100%",
                  justifyContent: "center",
                }}
              >
                <span
                  style={{
                    flex: 1,
                    borderBottom: "1px solid #ddd",
                    margin: "0 10px",
                  }}
                />
                {formattedDate}
                <span
                  style={{
                    flex: 1,
                    borderBottom: "1px solid #ddd",
                    margin: "0 10px",
                  }}
                />
              </span>
            </div>
          )}

          <div
            className={
              chat.senderId === "admin"
                ? styles.adminMessage
                : styles.userMessage
            }
          >
            <p style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              {chat.message}
              <span
                style={{
                  fontSize: "10px",
                  color: "grey",
                  marginTop: "auto",
                }}
              >
                {formatTime(chat.createdAt)}
              </span>
            </p>

            {chat.senderId === userid &&
              chat.options &&
              chat.options.length > 0 &&
              renderOptions(chat.options)}
          </div>
        </React.Fragment>
      );
    })
  ) : (
    <div>No messages available</div>
  )}
  <div ref={chatEndRef} />
</div>

            

{selectUser?.status === "close" ? 

<div  style={{textAlign:'center' }}>This Chat is Closed By the Admin</div>
: (isAdminAssigned&&isAdminAssigned!==currentAdmin) ? <div  style={{textAlign:'center' }}>Admin has been already assigned</div> :  <div className={styles.chatInput}>
              <input
                onChange={(e) => setMessage(e.target.value)}
                value={message}
                type="text"
                onKeyDown={onKeyDown}
                placeholder="Type a message..."
              />
              <button onClick={onClickSend}  >Send</button>
            </div> }

           
          </>
        ) : (
          <div className={styles.noChatSelected}>
            Select a user to start chatting
          </div>
        )}
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      logoutRequest: actions.auth.logout,
      startLoadingRequest: actions.loader.startLoading,
      stopLoadingRequest: actions.loader.stopLoading,
    },
    dispatch
  );

export default connect(null, mapDispatchToProps)(HelpCenter);
